import { useEffect, useRef } from "react";

import { useAnalytics } from "hooks/useAnalytics";

export const usePanelViewedOnce = (
  eventName: string,
  key: string | null,
  properties?: Record<string, string | number | boolean>
): void => {
  const { trackEvent } = useAnalytics();
  const viewedKeyRef = useRef<string | null>(null);

  useEffect(() => {
    if (!key) return;
    if (viewedKeyRef.current === key) return;
    viewedKeyRef.current = key;
    trackEvent(eventName, properties ?? {});
  }, [eventName, key, properties, trackEvent]);
};
